(function($) {
  "use strict";

  window.__mobile_feedback = {
    /**
     * Initializes the mobile feedback
     * optimization package.
     */
    init: function(data) {
      // - set click listeners
      this.augmentButtons();

      // - on page load always show loader
      $('#loading-overlay').show();

      // - when loading image is done, hide
      $(document).imagesLoaded()
        .always(function(instance) { $('#loading-overlay').hide(); })
        .done(function(instance) { $('#loading-overlay').hide(); })
        .fail(function(instance) { $('#loading-overlay').hide(); });

      // - fallback max 3.5 seconds of loading
      setTimeout(function() {
        $('#loading-overlay').hide();
      }, 3500);
    },

    /**
     * Initializes click listeners for buttons
     * that produce a page reload to display loader.
     */
    augmentButtons: function() {
      // bottom mobile navigation
      $('a.bottom-nav-icons').on('click, touchstart', function(e) {
        var $loading = $('#loading-overlay');
        if (!$loading.is(':visible')) {
          $loading.show();
          setTimeout(function() {
            $('#loading-overlay').hide();
            e.continueProp
          }, 1800);
        }

        // continue click propagation
        return true;
      });

      // interactions with page reloads
      $('a.__js_click_loader').on('click, touchstart', function(e) {
        var $loading = $('#loading-overlay');
        if (!$loading.is(':visible')) {
          $loading.show();
          setTimeout(function() {
            $('#loading-overlay').hide();
          }, 1800);
        }

        // continue click propagation
        return true;
      });

      // interactions with page reloads
      $('.__js_icon_button').on('click, touchstart', function(e) {
        e.stopPropagation();
        return $(this).parent('a.__js_click_loader').trigger('click');
      });
    }
  };
  
})(jQuery);
